import React, { useState, useContext } from 'react';
import { string, bool, func } from 'prop-types';
import classNames from 'classnames/bind';
import { Overlay } from '@thd-olt-component-react/overlay';
import { Button } from '@thd-olt-component-react/button';
import { MOBILE } from '@thd-olt-functional/utils';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { HOME_SERVICES_BADGE_URL } from '../../utils/constants';
import styles from './cta-section.scss';

const cx = classNames.bind(styles);

const CtaSection = ({
  buttonText, hideBadge, hideContactInfo,
  buttonLink, contactNumber, onClick, openContentInOverlay
}) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const expData = useContext(ExperienceContext);
  const { channel } = expData;

  const handleClick = () => {
    onClick();
    if (!openContentInOverlay) {
      window.open(buttonLink, '_blank');
      return;
    }
    setIsOverlayOpen(!isOverlayOpen);
  };

  return (
    <div className={cx('cta-section')}>
      { !hideBadge && (
        <img
          src={HOME_SERVICES_BADGE_URL}
          alt=""
          aria-hidden="true"
          className={cx('cta-section__badge')}
          width={channel === MOBILE ? '90px' : '110px'}
          height="50px"
        />
      )}
      <div className={cx('cta-section__cta-button-wrapper')}>
        <Button onClick={handleClick}>
          { buttonText }
        </Button>
        {
          !hideContactInfo && contactNumber && (
            <span className={cx('cta-section__contact-info')}>
              Or call
              <a
                className={cx('cta-section__contact-link')}
                href={`tel:${contactNumber}`}
              >
                { contactNumber }
              </a>
            </span>
          )
        }
      </div>

      {isOverlayOpen
      && (
        <Overlay onClose={handleClick} open medium closeButton>
          <iframe title="title" src={buttonLink} width="100%" height="99%" />
        </Overlay>
      )}
    </div>
  );
};

CtaSection.displayName = 'CtaSection';

CtaSection.propTypes = {
  hideBadge: bool,
  hideContactInfo: bool,
  buttonLink: string.isRequired,
  buttonText: string.isRequired,
  contactNumber: string,
  onClick: func,
  openContentInOverlay: bool
};

CtaSection.defaultProps = {
  hideBadge: false,
  hideContactInfo: false,
  contactNumber: '',
  onClick: () => {},
  openContentInOverlay: true
};

export { CtaSection };